import { reportAPI } from '@/services-ts/axios'
import type { IGetTierReport } from '@/types/Request'
import { defineStore } from 'pinia'

export const useTierReportStore = defineStore('tierReport', {
  actions: {
    async GetTopTierReportByContent(payload: IGetTierReport) {
      const { data, status } = await reportAPI.TierReportServices.GetTopTierReportByContent(payload)
      return status ? data : { data: [], totalCount: 0 }
    },

    async GetTopTierReportByDays(payload: IGetTierReport) {
      const { data, status } = await reportAPI.TierReportServices.GetTopTierReportByDays(payload)
      return status ? data : { data: [], totalCount: 0 }
    },

    async GetTopTierReportByHours(payload: IGetTierReport) {
      const { data, status } = await reportAPI.TierReportServices.GetTopTierReportByHours(payload)
      return status ? data : { data: [], totalCount: 0 }
    },

    async GetTopTierReportByPerson(payload: IGetTierReport) {
      const { data, status } = await reportAPI.TierReportServices.GetTopTierReportByPerson(payload)
      return status ? data : { data: [], totalCount: 0 }
    },

    async GetTopTierReportByDepartment(payload: IGetTierReport) {
      const { data, status } =
        await reportAPI.TierReportServices.GetTopTierReportByDepartment(payload)
      return status ? data : { data: [], totalCount: 0 }
    },

    async GetTopTierReportByLocation(payload: IGetTierReport) {
      const { data, status } =
        await reportAPI.TierReportServices.GetTopTierReportByLocation(payload)
      return status ? data : { data: [], totalCount: 0 }
    },

    async GetTopTierReportByCategory(payload: IGetTierReport) {
      const { data, status } =
        await reportAPI.TierReportServices.GetTopTierReportByCategory(payload)
      return status ? data : { data: [], totalCount: 0 }
    },

    async GetTopTierReportByCity(payload: IGetTierReport) {
      const { data, status } = await reportAPI.TierReportServices.GetTopTierReportByCity(payload)
      return status ? data : { data: [], totalCount: 0 }
    },

    async GetTopTierReportByWorkerType(payload: IGetTierReport) {
      const { data, status } =
        await reportAPI.TierReportServices.GetTopTierReportByEmployeeWorkerType(payload)
      return status ? data : { data: [], totalCount: 0 }
    },

    async GetTopTierReportByContentExcel(data: IGetTierReport) {
      await reportAPI.TierReportServices.GetTopTierReportByContentExcel(data)
    },

    async GetTopTierReportByDaysExcel(data: IGetTierReport) {
      await reportAPI.TierReportServices.GetTopTierReportByDaysExcel(data)
    },

    async GetTopTierReportByHoursExcel(data: IGetTierReport) {
      await reportAPI.TierReportServices.GetTopTierReportByHoursExcel(data)
    },

    async GetTopTierReportByPersonExcel(data: IGetTierReport) {
      await reportAPI.TierReportServices.GetTopTierReportByPersonExcel(data)
    },

    async GetTopTierReportByDepartmentExcel(data: IGetTierReport) {
      await reportAPI.TierReportServices.GetTopTierReportByDepartmentExcel(data)
    },

    async GetTopTierReportByLocationExcel(data: IGetTierReport) {
      await reportAPI.TierReportServices.GetTopTierReportByLocationExcel(data)
    },

    async GetTopTierReportByCategoryExcel(data: IGetTierReport) {
      await reportAPI.TierReportServices.GetTopTierReportByCategoryExcel(data)
    },

    async GetTopTierReportByCityExcel(data: IGetTierReport) {
      await reportAPI.TierReportServices.GetTopTierReportByCityExcel(data)
    },

    async GetTopTierReportByWorkerTypeExcel(data: IGetTierReport) {
      await reportAPI.TierReportServices.GetTopTierReportByEmployeeWorkerTypeExcel(data)
    },
  },
})
